import React from 'react';

import { Box, Typography } from '@mui/material';

import { Testimonial } from '../data/Testimonials';

function TestimonialQuote({ testimonial }: { testimonial: Testimonial }) {
  const attribution = [testimonial.name, testimonial.role, testimonial.organization]
    .filter(Boolean)
    .join(', ');
  return (
    <Box
      component='figure'
      sx={{
        m: 0,
        p: { xs: 2.5, md: 3 },
        minWidth: 0,
        borderRadius: 2,
        bgcolor: '#EFF6FC',
        borderLeft: '4px solid #005596',
        overflowWrap: 'anywhere',
      }}
    >
      <Typography
        component='blockquote'
        variant='body1'
        sx={{ m: 0, color: '#0B2545', fontStyle: 'italic' }}
      >
        “{testimonial.quote}”
      </Typography>
      <Typography
        component='figcaption'
        variant='body2'
        sx={{ mt: 1.5, color: '#0B2545' }}
      >
        <Box
          component='span'
          sx={{ display: 'block', fontWeight: 700 }}
        >
          {attribution}
        </Box>
        <Box
          component='span'
          sx={{ display: 'block', color: '#334155' }}
        >
          {testimonial.context}
        </Box>
      </Typography>
    </Box>
  );
}

export default TestimonialQuote;
